import { useLocation } from "react-router";

const travelRoutes = [
  "/loja/hoteis",
  "/loja/search-hotels-result",
  "/loja/hotel",
  "/loja/hotel-travellers",
  "/loja/passagens-aereas",
  "/loja/passagens-aereas/voos",
  "/loja/search-travel",
  "/loja/search-cars-result",
  "/loja/car-conductor",
];

const funnelEndRoutes = [
  "/loja/orderresumepag",
  "/loja/orderplaced",
  "/loja/orderplacedsuccessfully",
  "/loja/ordernotapproved",
];

const hiddenPrefixes = [
  "/loja/checkout-travel",
  "/loja/resumo-hotel",
  "/loja/orderresumestatus",
  "/loja/checkout-message-travel",
  "/loja/pixconfirmation",
  "/loja/policy",
  "/loja/myaccount",
  "/loja/pj/myaccount",
];

export function useSearchVisibility() {
  const location = useLocation();
  const path = location.pathname;

  const isTravelRoute = travelRoutes.some((route) => path.startsWith(route));
  const isFunnelEndRoute = funnelEndRoutes.some((route) => path.startsWith(route));
  const isHiddenPrefix = hiddenPrefixes.some((route) => path.startsWith(route));

  return !isTravelRoute && !isFunnelEndRoute && !isHiddenPrefix;
}
